import {
  AccountActions,
  type EmailChoicesChange,
  selectEmailChoices,
} from '@store/reducers/account'
import { useDispatch, useSelector } from 'react-redux'

// The account saga loads the choices when the page is entered and saves a
// change; the section only reads the store
export const useEmailChoices = () => {
  const dispatch = useDispatch()
  const choices = useSelector(selectEmailChoices)

  const update = (change: EmailChoicesChange) =>
    dispatch(AccountActions.updateEmails(change))

  return { choices, update }
}
